export default __webpack_public_path__ + "static/media/project-wizard-csv_dark.c62b44d1.png";